import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  code: [validatePresence(true)],
  description: []
};
